import { render, staticRenderFns } from "./ExternalProjectDetail.vue?vue&type=template&id=540b715f&scoped=true&"
import script from "./ExternalProjectDetail.vue?vue&type=script&lang=js&"
export * from "./ExternalProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExternalProjectDetail.vue?vue&type=style&index=0&id=540b715f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540b715f",
  null
  
)

export default component.exports